import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, state } = useLocation();

  useEffect(() => {
    // Если условие выполнено, не прокручивать страницу

    if (pathname.startsWith("/collection") && state?.isTabChanged) {
      return;
    }
    if (pathname.startsWith("/user") && state?.isTabChanged) {
      return;
    }

    window.scrollTo(0, 0);
  }, [pathname, state?.isTabChanged]);

  return null;
}
